var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconArrowAsc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-transfer-vertical-1 5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9953 13.9953C12.0979 12.8927 13 11.9822 13 11.972C13 11.9617 12.8162 11.7695 12.5917 11.5447L12.1833 11.1361L11.1644 12.1548L10.1455 13.1736V7.29102L10.1455 1.40845H9.55399H8.96244L8.96244 8.70422C8.96244 12.7169 8.96879 16 8.97656 16C8.98432 16 9.89277 15.0979 10.9953 13.9953Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.10352 7.29578C7.10352 3.2831 7.09719 1.90735e-06 7.08947 1.90735e-06C7.08173 1.90735e-06 6.16909 0.906293 5.06136 2.01399L3.04729 4.02798L3.46496 4.44597L3.88263 4.86395L4.90153 3.84519L5.92042 2.82643L5.92042 8.70898L5.92042 14.5916H6.51197H7.10352L7.10352 7.29578Z",
    fill: "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowAsc);
export default __webpack_public_path__ + "static/media/icon--arrow-asc.2bbfa68e7e3296c399f845ef6887a5a7.svg";
export { ForwardRef as ReactComponent };